import { Pipe, PipeTransform } from '@angular/core';
import { FilterModel } from './filter-checkbox-tree.component';

@Pipe({
  name: 'subFiltersSelected'
})
export class SubFiltersSelectedPipe implements PipeTransform {

  transform(values: FilterModel<any>[]): boolean|null {
      if (values.length == 0) return false;
      let firstValue = values[0].selected;
      for (let value of values) {
          //null indicates intermediate, some are checked, and some are not
          if (value.selected !== firstValue) return null;
      }
      //all values are the same as the first value
      return firstValue;
  }

}
